﻿import State from './State.js';
import ScoreCalculator from './ScoreCalculator.js';
///context is the type of CribbageGame
export default class StatePlay extends State {
    constructor(context) {
        super(context);
        this.name = 'play';
        this.calc = new ScoreCalculator();
    }
    setup() {
        this.context.goPlayer = null;
        this.context.playCount = null;

        //Starting with the player on the dealer's left
        let dealer = this.context.dealer;
        this.context.playerTurn = (dealer === "player1") ? "player2" : "player1";

        this.createMessage();
    }
    cleanUp() {
        this.context.playCount = null;
    }
    action(command, value, player) {
        switch (command) {
            case "play": return this.play(value, player); break;
            case "go": return this.go(value, player); break;
            case "clear": return this.clear(value, player); break;
            case "show": return this.show(value, player); break;
            default: return this.unknownCommand(command, value, player);
        }

    }
    getActions(player) {
        let actions = [];

        let pileHand = [];

        if (this.isPlayOver()) {
            actions.push({ command: "show", value: null });
            return actions;
        }

        if (this.isSeriesOver()) {
            actions.push({ command: "clear", value: null });
            return actions;
        }

        if (this.context.playerTurn !== player) return [];

        let playableCards = this.getPlayableCards(player);
        for (let i = 0; i < playableCards.length; i++) {
            let card = playableCards[0];
            actions.push({ command: "play", value: card.id, player: player });
        }

        //if no playable cards
        if (playableCards.length === 0) {
            if (!this.context.goPlayer) {
                actions.push({ command: "go", value: null, player: player });
            }
        }

        return actions;
    }
    getPlayableCards(player) {
        let pileHand = [];
        let playerTurn = this.context.playerTurn;

        if (playerTurn !== player) return [];

        if (playerTurn === "player1")
            pileHand = this.context.getPile("hand1");
        if (playerTurn === "player2")
            pileHand = this.context.getPile("hand2");

        //get play total
        let pilePlay = this.context.getPile("play");
        let playTotal = this.cardsTotal(pilePlay);

        //get playable cards
        let playableCards = [];
        for (var i = 0; i < pileHand.length; i++) {
            var card = pileHand[i];
            if (card.value + playTotal <= 31) {
                playableCards.push(card);
            }
        }
        return playableCards;
    }
    createMessage() {
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";

        if (this.isPlayOver()) return;

        if (this.isSeriesOver()) {
            return;
        }

        if (this.context.playerTurn === "player1") {
            let pileHand1 = this.context.getPile("hand1");
            if (pileHand1.length > 0) {
                //this.context.sendEvent("message", "Play a card", "player1");
                this.context.messagePlayer1 = "Play a card";
            }
        } if (this.context.playerTurn === "player2") {
            let pileHand2 = this.context.getPile("hand2");
            if (pileHand2.length > 0) {
                //this.context.sendEvent("message", "Play a card", "player2");
                this.context.messagePlayer2 = "Play a card";
            }
        }



    }
    play(cardId, player) {
        if (this.context.playerTurn !== player) {
            this.invalidMove("It is not your turn.", player);
            return;
        }
        let card = this.context.getCard(cardId);

        //check if played from right hand
        if (this.context.playerTurn === "player1" && card.pile !== "hand1") {
            this.invalidMove("It is player 1's turn.", player);//  You can only play a card from 'hand1'");
            return;
        }
        //check if played from right hand
        if (this.context.playerTurn === "player2" && card.pile !== "hand2") {
            this.invalidMove("It is player 2's turn.", player);//  You can only play a card from 'hand2'");
            return;
        }
        //check if played from right hand
        if (!card) {
            this.invalidMove("Not a card", player);
            return;
        }
        let peggingTotal = this.peggingTotal();
        if (card.value + peggingTotal > 31) {
            this.invalidMove("Pegging total can't exceed 31.", player);
            return;
        }



        card.showfront = false;
        this.context.addToPile(card, "play");



        //check for points
        let pilePlay = this.context.getPile("play");
        let pointsPegging = this.calc.scorePeggingPoints(pilePlay, card.owner);
        //also check for last card

        //award points for last card
        let playTotal = this.cardsTotal(pilePlay);
        if (playTotal !== 31) { //if 31, then the points were already awarded
            if (this.isSeriesOver()) {
                pointsPegging.push({
                    'points': 1,
                    'player': card.owner,
                    'reason': "last card",
                    'pile': "play",
                    'cards': pilePlay
                });
            }
        }


        this.context.awardPointsArray(pointsPegging);


        //set playCount on model
        this.context.playCount = this.peggingTotal();

        //get next players turn
        this.nextPlayerTurn();

        // //is Series Over then reset
        // if (this.isSeriesOver()) {
        //     this.endSeries();
        // }

        // //is play over then - go to next state
        // if (this.isPlayOver()) {
        //     this.context.setState("show");
        // }

        this.createMessage();

        return true;
    }
    peggingTotal() {
        let pilePlay = this.context.getPile("play");
        let playTotal = this.cardsTotal(pilePlay);
        return playTotal;
    }
    go(value, player) {
        if (this.context.playerTurn !== player) {
            this.invalidMove("It is not your turn.", player);
            return;
        }

        let playableCards = this.getPlayableCards(player);
        if (playableCards.length > 0) {
            this.invalidMove("You still have playable cards.", player);
            return;
        }
        if (this.context.goPlayer !== null) {
            this.invalidMove("Go already done.", player);
            return;
        }

        let goPlayer = this.context.playerTurn;
        this.context.goPlayer = goPlayer;
        this.nextPlayerTurn();

        //award points for last card
        let playTotal = this.peggingTotal();
        if (playTotal !== 31) { //if 31, then the points were already awarded
            if (this.isSeriesOver()) {
                let pilePlay = this.context.getPile("play");
                let card = pilePlay[pilePlay.length - 1];
                let cardOwner = card ? card.owner : null;
                let pointsPegging = [];
                pointsPegging.push({
                    'points': 1,
                    'player': cardOwner,
                    'reason': "last card",
                    'pile': "play",
                    'cards': pilePlay
                });
                this.context.awardPointsArray(pointsPegging);
            }
        }

        //reset round on "go" if no one can go

        // //is Series Over then reset
        // if (this.isSeriesOver()) {
        //     this.endSeries();
        // }

        // //is play over then - go to next state
        // if (this.isPlayOver()) {
        //     this.context.setState("show");
        // }

        this.context.sendEvent("message", "Go", player);
        this.createMessage();
        if (this.context.goPlayer === "player1") this.context.messagePlayer1 = "Go";
        if (this.context.goPlayer === "player2") this.context.messagePlayer2 = "Go";


        return true;
    }

    clear() {
        if (this.isSeriesOver()) {
            this.endSeries();
        }
        //  if (this.isPlayOver()) {
        //      this.context.setState("show");
        //  }
        this.createMessage();
        return true;
    }
    show() {
        if (this.isPlayOver()) {
            this.context.logPegging();
            this.context.setState("showNonDealerHand");
        }
        return true;
    }

    isPlayOver() {
        let pileHand1 = this.context.getPile("hand1");
        let pileHand2 = this.context.getPile("hand2");
        let pilePlay = this.context.getPile("play");

        //check if all cards have been played 
        if (pileHand1.length === 0 && pileHand2.length === 0 && pilePlay.length === 0) {
            return true;
        }
        return false;
    }
    endSeries() {
        let pilePlay = this.context.getPile("play");
        let lastCardPlayed = pilePlay.slice(-1);

        //note: could award last card here instead of in play/go 


        this.context.playCount = 0;
        //reset series
        for (var i = 0; i < pilePlay.length; i++) {
            let card = pilePlay[i];
            this.context.addToPile(card, "played");
        }
        this.context.goPlayer = null;

        //next turn - base on last card played is other players turn to start
        if (lastCardPlayed.length === 1) {
            let card = lastCardPlayed[0];
            if (card.owner === "player1") {
                this.context.playerTurn = "player2";
            } else {
                this.context.playerTurn = "player1";
            }
        }
    }
    isSeriesOver() {
        let pilePlay = this.context.getPile("play");
        let playTotal = this.cardsTotal(pilePlay);
        let pileHand1 = this.context.getPile("hand1");
        let pileHand2 = this.context.getPile("hand2");
        let goPlayer = this.context.goPlayer;

        //total 31
        if (playTotal === 31) {
            return true;
        }

        //no one can go and someone said 'go' or does not have any cards which implis go
        if (this.canAnyOnePlay() === false) {

            if (goPlayer != null) {
                return true;
            }
            if (pileHand2.length === 0) {
                return true;
            }
            if (pileHand1.length === 0) {
                return true;
            }
        }


        // if (this.canAnyOnePlay() === false) {
        //     return true;
        // }

    }
    nextPlayerTurn() {

        if (this.context.playerTurn === "player1") {
            let pileHand = this.context.getPile("hand2");
            if (this.context.goPlayer !== "player2" && pileHand.length > 0) {
                this.context.playerTurn = "player2";
            }
        } else if (this.context.playerTurn === "player2") {
            let pileHand = this.context.getPile("hand1");
            if (this.context.goPlayer !== "player1" && pileHand.length > 0) {
                this.context.playerTurn = "player1";
            }
        }
    }


    canPlay(pileHand) {
        let pilePlay = this.context.getPile("play");
        let playTotal = this.cardsTotal(pilePlay);

        for (var i = 0; i < pileHand.length; i++) {
            let card = pileHand[i];
            if (card.value + playTotal <= 31) {
                return true;
            }
        }
        return false;
    }
    canAnyOnePlay() {
        let pileHand1 = this.context.getPile("hand1");
        let pileHand2 = this.context.getPile("hand2");
        let pilePlay = this.context.getPile("play");

        let playTotal = this.cardsTotal(pilePlay);

        //check if no one can go, then clear the "play" pile (all card will break 31)
        //get playable cards
        let playableCards = 0;
        for (var i = 0; i < pileHand1.length; i++) {
            let card = pileHand1[i];
            if (card.value + playTotal <= 31) {
                playableCards++;
            }
        }
        for (var i = 0; i < pileHand2.length; i++) {
            let card = pileHand2[i];
            if (card.value + playTotal <= 31) {
                playableCards++;
            }
        }
        return playableCards !== 0;
    }
    cardsTotal(cards) {
        var total = cards.reduce(function (sum, card) {
            return sum + card.value;
        }, 0);
        return total;
    }
    // getPeggingSamesLength(cards) {
    //     if (!cards) return 0;
    //     if (cards.length === 0) return 0;
    //     if (cards.length === 1) return 1;
    //     let same = 0;
    //     let lastCard = cards[cards.length - 1];

    //     //loop backwards
    //     for (let i = cards.length; i--;) {
    //         let card = cards[i];
    //         if (lastCard.number === card.number) {
    //             same += 1;
    //         } else {
    //             return same;
    //         }
    //     }


    //     return same;
    // }
    // getPeggingRunLength(cards) {
    //     const maxRunLength = 10;
    //     const minRunLength = 3;
    //     for (let i = maxRunLength; i > minRunLength - 1; i--) {
    //         let runLength = i;
    //         if (cards.length >= runLength) {
    //             let lastCards = cards.slice(-runLength);
    //             let orderedCards = lastCards.sort(function (a, b) {
    //                 return a.number - b.number;
    //             });
    //             let isInOrder = true;
    //             for (let i = 0; i < orderedCards.length - 1; i++) {
    //                 let card = orderedCards[i];
    //                 let nextCard = orderedCards[i + 1];
    //                 if (card.number + 1 !== nextCard.number) {
    //                     isInOrder = false;
    //                     break;
    //                 }
    //             }
    //             if (isInOrder) {
    //                 return runLength;
    //             }
    //         }
    //     }
    //     return 0;
    // }
    invalidMove(message, player) {
        this.context.sendEvent("invalidMove", message, player);
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}